import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Container, Row, Col } from "react-bootstrap";

const SafariViewHeaderSkeleton = () => {
  return (
    <section className="safari_wrapper bg-white pt-4 pb-0">
      <Container>
        <Row className="mb-4">
          <Col lg={12}>
            <div className="wrapper-skybgsafri bg-white pb-0">
              <Row className="border_bottom2 pb-4">
                <Col lg={8} md={8} className="border-right">
                  <Row>
                    <Col sm={3} md={3} lg={2} xs={3} className="maxWidth">
                      <Skeleton height={100} width="100%" />
                    </Col>
                    <Col xs={9} lg={10} md={9} sm={9} className="col-9 pt-sm-0 pt-3 maxWidth">
                      <div className="safrititles">
                        <h5><Skeleton width={200} /></h5>
                        <div className="date_bx font-wee">
                          <Skeleton width={150} />
                        </div>
                        <h6 className="titler_safari">
                          <Skeleton width={200} />
                        </h6>
                        <Skeleton width={180} />
                      </div>
                    </Col>
                  </Row>
                </Col>

                <Col lg={4} className="pt-lg-0 pt-4">
                  <Row className="px-sm-2 px-0">
                    {[...Array(7)].map((_, i) => (
                      <Col sm={6} className="col-12 mb-3" key={i}>
                        <div className="safridetails_form d-flex gap-3 align-items-center">
                          <div className="iconImg">
                            <Skeleton  width={20} height={20} />
                          </div>
                          <div className="text-form ms-3">
                            <Skeleton width={100} />
                          </div>
                        </div>
                      </Col>
                    ))}
                  </Row>
                </Col>
              </Row>

              <Row className="pt-md-4 align-items-center gx-4 pb-4">
                <Col lg={6} className="d-flex align-items-center">
                  <Skeleton width={250} />
                  <div className="sociel_icons ps-xl-3 d-flex gap-2 mt-0">
                    {[...Array(5)].map((_, i) => (
                      <Skeleton key={i} width={30} height={30} circle />
                    ))}
                  </div>
                </Col>

                <Col lg={6} className="d-lg-block mobile_didplay_block">
                  <div className="btn_wrap float-lg-end pt-lg-0 pt-3 d-flex gap-2 align-items-center">
                    <Skeleton width={132} height={40} />
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default SafariViewHeaderSkeleton;
